import { copilotDotCom } from 'src/constants/hostnameConsts';

export const CUSTOM_DOMAIN_CARD_TITLE = 'Connect a custom domain';
export const CUSTOM_DOMAIN_CARD_DESCRIPTION =
  'Host portal on your own website to provide clients a completely on-brand experience. Once setup, your portal will be accessible on portal.<yourCompanyURL>.com';
export const CUSTOM_DOMAIN_LEARN_MORE_LINK = `https://www.${copilotDotCom.prod}/guide/custom-domains`;
export const COPILOT_CHANGELOG_LINK = `https://www.${copilotDotCom.prod}/updates`;
